import { BaseService } from "./BaseService";
import { SnackBarModule } from "../modules/SnackBarModule";

export const ReprogramarFeriasService = {
  async salvarAlteracao(postData) {
    const response = await BaseService.fetchResponseFromAPIPost(
      `civil/reprogramacao`,
      postData,
    );
    if (response.error) {
      const errorMessage = await response.message;
      SnackBarModule(errorMessage.sucesso || "Erro desconhecido", "error");
      return false;
    }
    const successMessage = await response.message; 
    SnackBarModule(successMessage.sucesso, "success");
    return true;
  },
}